module.exports = __webpack_public_path__ + "img/volume_up.3a4db2f3.svg";